const CircleArrowDown03Icon = /*#__PURE__*/ [
  ["path", { d: "M12 22C17.5228 22 22 17.5228 22 12C22 6.47715 17.5228 2 12 2C6.47715 2 2 6.47715 2 12C2 17.5228 6.47715 22 12 22Z", stroke: "currentColor", strokeWidth: "1.5", key: "0" }],
  ["path", { d: "M14.5147 11.494C13.985 12.0258 12.6954 14.006 11.9501 13.997C11.2121 13.9178 10.0318 11.998 9.51097 11.4939M12.0257 6.99835V13.9915M8.01074 17.0018H16.0028", stroke: "currentColor", strokeLinecap: "round", strokeLinejoin: "round", strokeWidth: "1.5", key: "1" }]
];

export { CircleArrowDown03Icon as default };
//# sourceMappingURL=CircleArrowDown03Icon.js.map
